/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 17th February 2019
 *
 *  Customer Portal Primary Container
 */
import React from 'react';
import { observer } from 'mobx-react';
import { Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useStores } from 'stores/RootStore';

// Material UI
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

// Containers
import EmailVerification from 'containers/pages/Portal/views/EmailVerification';
import BadgeHistory from 'components/UserProfile/BadgeHistory';
import CompanyProfile from 'components/CompanyProfile';
import LocationProfile from 'components/LocationProfile';
import UserProfile from 'components/UserProfile';

// Components
import Header from 'components/Headers/Header';
import ViewHeader from 'components/Headers/ViewHeader';
import Footer from 'components/Footers/Footer';

const Portal = props => {
  const { classes } = props;
  const stores = useStores();
  const { isAuth, isLoading, isCompanyUser, isVendorUser, isVerified } = stores.authStore;

  // Update Page Title
  stores.appStore.setPage('Portal');
  stores.portalStore.loading.hidePageLoader();
  stores.appStore.debug('Portal [Page] Rendered successfully.');

  return isLoading ? null : (
    <div className={classes.root}>
      <Header />
      <Grid container justify='center' alignContent='flex-start' className={classes.gridContainer}>
        <Grid item xs={12}>
          <ViewHeader />
          <Switch>
            {/* If user has not verified email, EmailVerification component will render for all paths */}
            {!isVerified ? <Route render={props => <EmailVerification {...props} />} /> : null}

            {isVendorUser ? (
              <Route
                exact
                path='/badge-history'
                render={props => (
                  <Grid container justify='center'>
                    <BadgeHistory {...props} />
                  </Grid>
                )}
              />
            ) : null}
            <Route path='/location/:id' render={props => <LocationProfile {...props} />} />
            <Route exact path='/profile' render={props => <UserProfile {...props} />} />

            {/* Company Users Only Routes */}
            {isCompanyUser ? <Route path='/company' render={props => <CompanyProfile {...props} />} /> : null}

            {/* Home Page */}
            <Route
              exact
              path='/'
              render={props =>
                isCompanyUser ? (
                  <Redirect to='/company/users' />
                ) : isVendorUser ? (
                  <Grid container justify='center'>
                    <BadgeHistory {...props} />
                  </Grid>
                ) : null
              }
            />

            {/* Page Not Found, redirect to root */}
            <Redirect from='*' to='/' />
          </Switch>
        </Grid>
      </Grid>
      <Footer />
    </div>
  );
};

Portal.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = theme => ({
  '@global html': {
    backgroundColor: theme.palette.background.default,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'calc(100vh - 4px)',
    minWidth: '320px',
    backgroundColor: theme.palette.background.default,
  },
  gridContainer: {
    flex: 1,
    paddingLeft: '5%',
    paddingRight: '5%',
    marginBottom: '15px',
  },
});

export default withStyles(styles, { withTheme: true })(observer(Portal));
